export default "__VITE_ASSET__DF5VRf8T__"